<!--头部-->
<template>
    <div class="container">
        <div class="logo">
            <el-carousel height="440px" indicator-position="none" :interval="4000">
                <el-carousel-item v-for="(item,index) in bannerList" :key="index">
                    <img style="height:440px;width:100%;" :src="item.attachUrl" alt="">
                </el-carousel-item>
            </el-carousel>
            <div class="tool-tip">
                <div class="border-right" :class="index=='/'?'active-tip':'inactive-tip'" @click="clickNav(0)">首页</div>
                <div class="border-right" :class="index=='/'+i?'active-tip':'inactive-tip'" @click="toList(i,item.id,item.name)" v-for="(item,i) in menuList" :key="i">{{item.name}}</div>
            </div>
        </div>
    </div>
</template>
<script>
import {  get,post } from "@/api/common/index";
export default {
    data() {
        return {
            config:config,
            bannerList:[],
            index:null,
            menuList:[]
        };
    },
    methods: {
        toList(index,id,name){
            this.index = '/'+index
            if(name=='重点项目'){
                this.$router.push({path:'/ProjectList',query:{id:id,index:index}})
            }else{
                this.$router.push({path:'/InfoList',query:{id:id,index:index}})
            }
        },
        clickNav(id){
            switch(id){
                case 0:
                    this.index = '/'
                    this.$router.push('/')
                    break
            }
        },
        getMenuList(){
            get('/api/website/get_menu_list').then(res => {
                if (res.success) {
                    var list = res.data
                    list.pop()
                    this.menuList = list
                }
            }, error => {
                this.$message({
                    message: error,
                    type: "error",
                });
            })
        },
        getAttachmentList(){
            get('/api/website/get_attachment_list').then(res => {
                if (res.success) {
                    this.bannerList = res.data
                }
            }, error => {
                this.$message({
                    message: error,
                    type: "error",
                });
            })
        },
    },
    created() {
        
    },
    mounted() {
        if(this.$route.path=='/InfoList'||this.$route.path=='/ProjectList'){
            this.index = '/'+this.$route.query.index
        }else{
            this.index = this.$route.path
        }
        this.getMenuList()
        this.getAttachmentList()
    },
    watch:{
        $route(to,from){
            if(to.path=='/InfoList'||this.$route.path=='/ProjectList'){
                this.index = '/'+ to.query.index
            }else{
                this.index = '/'
            }
        },
        index:function(){
            
        }
    },
};
</script>
<style scoped>
.logo{
    width: 1298px;
    margin: 0 auto;
}
.tool-tip{
    display: flex;
    align-items: center;
    padding: 15px 0 ;
    justify-content: space-between;
    background: #1965b5;
}
.active-tip{
    color: #e2a129;
    width:147px;
    text-align: center;
    font-size: 20px;
}
.inactive-tip{
    color: #FFFFFF;
    width:147px;
    text-align: center;
    font-size: 20px;
    cursor: pointer;
}
.border-right:not(:last-child){
    border-right: 3px solid #FFFFFF;
}
.border-right{
    width: 16.4%;
}
</style>
